<template>
  <div>
    <div class="loading" v-if="loading">
      <div class="spinner"></div>
    </div>
    <b-card>
      <div slot="header" v-if="!add && lock">
        Webshell File Detail

        <span class="float-right">
          {{  model.created_at | datetime }}
        </span>
      </div>
      <div slot="header" v-if="!add && !lock">
        Modify Webshell File
      </div>
      <div slot="header" v-if="add && !lock">
        Create Webshell File
      </div>

      <b-row>
        <b-col md="3">
          <b-form-group class="text-primary" label="Clear" label-for="ph_is_clear">
            <c-switch color="info" label size="lg" id="ph_is_clear" v-model="model.is_clear" :disabled="lock" />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group class="text-primary" label="Status" label-for="ph_is_alive">
            <c-switch color="info" label size="lg" id="ph_is_alive" v-model="model.is_alive" :disabled="lock" />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group class="text-primary" label="From" label-for="ph_is_clear">
            <!-- <c-switch color="info" label size="lg" id="ph_is_clear" v-model="model.is_clear" :disabled="lock" /> -->
            <b-badge variant="danger" v-if="model.is_system">Crawler</b-badge>
            <b-badge v-else variant="warning">User</b-badge>
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group class="text-primary" label="Webshell" label-for="ph_is_webshell">
            <b-badge variant="danger" v-if="model.is_unknown">Suspicious</b-badge>
            <b-badge v-else variant="success">Confirmed</b-badge>
          </b-form-group>
        </b-col>

        <!-- <b-col md="6" v-if="!lock && !add">
          <b-form-group class="text-primary" label="Distribute" label-for="ph_is_use">
            <c-switch color="info" label size="lg" id="ph_is_use" v-model="model.distribute" :disabled="lock" />
          </b-form-group>
        </b-col> -->
      </b-row>
      <b-row>
        <b-col md="3">
          <b-form-group class="text-primary" label="Binary" label-for="ph_is_binary">
            <c-switch color="info" label size="lg" id="ph_is_binary" v-model="model.is_binary" :disabled="lock" />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group class="text-primary" label="Excuteable" label-for="ph_is_excute">
            <c-switch color="info" label size="lg" id="ph_is_excute" v-model="model.is_excute" :disabled="lock" />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group class="text-primary" label="Sync with Pattern" label-for="ph_is_pattern">
            <c-switch color="info" label size="lg" id="ph_is_pattern" v-model="model.is_pattern" :disabled="lock" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group class="text-primary">
            <label for="ph_origin">Origin</label>
            <b-input type="text" id="ph_origin" v-model="model.origin" :plaintext="lock"></b-input>
          </b-form-group>
        </b-col>

      </b-row>

      <b-row>
        <b-col md="3">
          <b-form-group class="text-primary" label="Approval" label-for="ph_is_approve">
            <c-switch color="info" label size="lg" id="ph_is_approve" v-model="model.is_approve" :disabled="lock" />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group class="text-primary" label="Obfuscation" label-for="ph_is_ob">
            <b-badge variant="info" v-if="model.is_ob">Obfuscated</b-badge>
            <span class="text-dark" v-else>-</span>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group class="text-primary" label="Obfuscation Tags" label-for="ph_is_ob">
            <b-badge variant="dark" class="m-1" v-for="(tag, i) in tags(model.ob_list)" v-bind:key="i">
              {{ tag }}
            </b-badge>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group class="text-primary" label="Size" label-for="ph_file_size">
            <!-- <c-switch color="info" label size="lg" id="ph_is_pattern" v-model="model.is_pattern" :disabled="lock" /> -->
            <span class="text-dark">
              {{ model.file_size | number }}
            </span>
          </b-form-group>
        </b-col>
      </b-row>

      <hr>

      <b-row>
        <b-col md="3">
          <b-form-group class="text-primary" label="Ai General Score" label-for="ph_ai_genaeral_score">
            <span class="text-danger font-weight-bold h5">

              <span v-if="model.ai_general_result === undefined">
                -
              </span>
              <span v-else>
                {{ model.ai_general_result || ' -' }}
                (Score: {{ model.ai_general_score }} )
              </span>


            </span>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group class="text-primary" label="Ai Specify Score" label-for="ph_ai_specify_score">
            <span class="text-danger font-weight-bold h5">
              <span v-if="model.ai_general_result === undefined">
                -
              </span>
              <span v-else>
                {{ model.ai_specify_result || ' -' }}
                (Score: {{ model.ai_specify_score }} )
              </span>

            </span>
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group class="text-primary" label="Hash (MD5)" label-for="ph_file_hash">
            <!-- <c-switch color="info" label size="lg" id="ph_is_pattern" v-model="model.is_pattern" :disabled="lock" /> -->
            <span class="text-dark">
              {{ model.file_hash }}
            </span>
          </b-form-group>
        </b-col>
      </b-row>

      <hr>

      <b-row>
        <b-col md="3">
          <b-form-group class="text-primary">
            <label for="ph_type">Extension</label>
            <!-- <v-select v-if="!lock" label="type" v-model="model.types" :options="rule_type" @input="changeDistribute"></v-select> -->
            <b-input type="text" :disabled="lock" :value="model.extension" plaintext></b-input>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group class="text-primary">
            <label for="ph_level">Extension Category</label>
            <b-input type="text" :value="model.extension_category" :plaintext="lock" aria-readonly="true"></b-input>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group class="text-primary">
            <label for="ph_level">File Signiture</label>
            <b-input type="text" :value="model.file_signiture" :plaintext="lock" aria-readonly="true"></b-input>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group class="text-primary">
            <label for="ph_level">Country</label>

            <b-input type="text" :value="model.country" :plaintext="lock" aria-readonly="true"></b-input>
            <span v-if="model.country" class="flag-icon" :class="`flag-icon-${model.country.toLowerCase()}`">
            </span>

          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12">
          <b-form-group class="text-primary">
            <label for="ph_file_name">Filename</label>
            <b-input type="text" id="ph_file_name" v-model="model.file.file_name" plaintext placeholder="Filename"></b-input>
          </b-form-group>
        </b-col>
      </b-row>

      <hr>
      <b-row>
        <b-col md="12">
          <b-form-group class="text-primary">
            <label for="ph_file_ssdeep">File SSDEEP</label>
            <b-input type="text" id="ph_file_ssdeep" v-model="model.file.file_ssdeep" plaintext></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="12">
          <b-form-group class="text-primary">
            <label for="ph_file_content">File Content</label>
            <codemirror @input="x => model.file_content = x" v-model="model.file_content" :options="options_rule" :style="{ height: '800px' }" :readonly="lock"/>
          </b-form-group>
        </b-col>
      </b-row>

      <hr>

      <b-button class= "mr-1" size="sm" variant="light" @click="back"> Back </b-button>
      <template v-if="lock">
        <div v-if="profile.permission == 'Master'" class="float-right">
          <!-- <b-button class= "mr-1" size="sm" variant="primary" @click="edit"> Modify </b-button> -->
          <b-button :disabled="model.is_approve" class="mr-2" size="sm" variant="warning" @click="confirm_allow = true"> Sync with Pattern </b-button>
          <b-button :disabled="model.is_approve" class="mr-2" size="sm" variant="primary" @click="confirm_deny = true"> Not Webshell </b-button>
          <b-button :disabled="model.is_approve" size="sm" variant="danger" @click="confirm = true"> Delete </b-button>
        </div>
      </template>
      <template v-else>
        <div class="float-right">
          <b-button class="mr-1" size="sm" variant="danger" @click="cancel"> Cancel </b-button>
          <b-button size="sm" variant="primary" @click="save"> Save </b-button>
        </div>
      </template>
    </b-card>
    <b-modal title="Confirm - Delete account" class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      Deleted data cannot be reversed. Are you sure?
    </b-modal>

    <b-modal title="Confirm - Sync with pattern" class="modal-warning" v-model="confirm_allow" @ok="allow" ok-variant="warning">
      Sync with pattern and deploy it. Are you sure?
    </b-modal>

    <b-modal title="Confirm - Not webshell" class="modal-primary" v-model="confirm_deny" @ok="deny" ok-variant="primary">
      is not a webshell ?, if deny this info, disable it
    </b-modal>
  </div>
</template>

<script>
import 'flag-icon-css/css/flag-icon.css';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import { api, auth } from '@/f1/service';
// import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
// import * as forge from 'node-forge'
// import reg from '@/f1/reg'
import 'vue-select/dist/vue-select.css';

import { codemirror } from 'vue-codemirror'

// import dedent from 'dedent'
// require styles
import 'codemirror/lib/codemirror.css'
// theme css
import 'codemirror/theme/dracula.css'; // Dracula 테마
import 'codemirror/theme/monokai.css'; // Monokai 테마
import 'codemirror/theme/material.css'; // Material 테마

// language
import 'codemirror/mode/vue/vue.js'
import 'codemirror/mode/php/php'; // PHP 코드 모드 가져오기
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css';
import 'codemirror/mode/python/python';



import 'codemirror/addon/scroll/annotatescrollbar.js'
import 'codemirror/addon/search/matchesonscrollbar.js'
import 'codemirror/addon/search/searchcursor.js'
import 'codemirror/addon/search/match-highlighter.js'
// keyMap
import 'codemirror/mode/clike/clike.js'
import 'codemirror/addon/edit/matchbrackets.js'
import 'codemirror/addon/comment/comment.js'
import 'codemirror/addon/dialog/dialog.js'
import 'codemirror/addon/dialog/dialog.css'
import 'codemirror/addon/search/searchcursor.js'
import 'codemirror/addon/search/search.js'
import 'codemirror/keymap/sublime.js'
// foldGutter
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/brace-fold.js'
import 'codemirror/addon/fold/comment-fold.js'
import 'codemirror/addon/fold/foldcode.js'
import 'codemirror/addon/fold/foldgutter.js'
import 'codemirror/addon/fold/indent-fold.js'
import 'codemirror/addon/fold/markdown-fold.js'
import 'codemirror/addon/fold/xml-fold.js'

const default_model = () => ({ is_alive: true, file: { file_content : '', file_hash : '', file_ssdeep : '', file_name: '' } });
// var beforeModel = {};

export default {
  components: { cSwitch, vSelect, DatePicker, codemirror },
  data : () => ({
      loading: false,
      confirm_allow: false,
      confirm_deny: false,
      options_rule: {
        tabSize: 4,
        highlightDifferences: true,
        // mode: 'text',
        theme: 'material',
        lineNumbers: true,
        line: true,
        mode: 'php',
        lineWrapping: true,
      },
      confirm: false,
      add: false,
      lock: true,
      model : default_model(),
      profile: auth.profile,
      analsisData : ""
  }),
  computed: {
    last_info() { return `${this.$options.filters.sdate(this.model.last_visit)} @ ${this.model.last_addr}`; }
  },
  methods: {
    tags(ob_list='[]') {
      try {
        return typeof '' == typeof ob_list ? JSON.parse(ob_list) : ob_list
      } catch (e) {
        console.log(e, ob_list)
        return []
      }
    },
    async allow() {
      try {
        let rs = await api.dms.webshell.allow([this.model.file_hash]);
        console.log("rs", rs)

        this.$toastr.s('Done.');
        this.get();

      } catch (e) { this.$toastr.e(e.data || e); }
    },

    async deny() {
      try {
        let rs = await api.dms.webshell.deny([this.model.file_hash]);
        console.log("rs", rs)

        this.$toastr.s('Done.'); this.cancel();

      } catch (e) { this.$toastr.e(e.data || e); }
    },

    cancel() {
      this.$router.go(this.$router.currentRoute)
      // this.$router.push({ name: 'uwss_webshell', params: { id: this.model.id }});
    },
    edit() { this.model; this.$router.replace({ name: 'uwss_webshell', params: { id: this.model.id, tag: 'edit' }}); },
    async remove() {
      try {
        await api.dms.webshell.delete(this.model.id);
        this.$emit('refresh'); this.$toastr.s('Rule deleted.'); this.list();
      } catch(e) { this.$toastr.e(e.data || e); this.list(); }
    },
    back() { this.$router.go(-1); },
    list() { this.$router.push({ name: 'uwss_webshell'}); },
    changeDistribute() { this.model.distribute = true; },
    async save() {
      if(!(this.model.file_hash || '').trim()) { return this.$toastr.e('File Hash required.'); }
      if(!(this.model.file_content || '').trim()) { return this.$toastr.e('File Content required.'); }
      if(!(this.model.file_ssdeep || '').trim()) { return this.$toastr.e('File ssdeep required.'); }

     try {
        if(this.model.id) {

          await api.dms.webshell.update(Object.assign({}, this.model, { file_content : btoa(this.model.file_content) }));
        } else {

          this.model.id = +(await api.dms.webshell.add(this.model));
        }
        this.$toastr.s('Done.');
        this.$parent.$emit('refresh');
        this.cancel();

      } catch(e) { this.$toastr.e(e.data || e); this.cancel(); }

      this.lock = true;
    },
    async get({ id, tag } = this.$route.params) {
      console.log('[vue] rule.detail', 'load item', id);

      if(id === 'add') { this.add = true; this.lock = false; this.model = default_model(); return; }
      else { this.add = false; }

      this.lock = (tag !== 'edit');

      try {
        this.loading = true;
        this.model = Object.assign({}, this.model, await api.dms.webshell.get(id));
        if(this.model.file) {
          this.model.file_content = atob(this.model.file.file_content)
        }
      }
      catch(e) { console.log(e); this.$toastr.e(e.data || e); this.list(); }
      finally {
        this.loading = false;
      }
    },
  },
  watch: { '$route' (to, from) { this.get(to.params); console.log(from) } },
  created() { },
  destroyed() { },
  mounted() {
    this.get(this.$route.params);
  }
}
</script>

<style>

body .CodeMirror-wrap {
  height: 800px !important;
}
</style>
